<template>
  <div>
    <presentacion-modulo-app :datos="data"></presentacion-modulo-app>
    <audio-player ref="audioPlayer" :autoplay="true" :audios="[
    'Modulo 1/AUDIO 01'
    ]"></audio-player> 
  </div>
</template>

<script>
export default {
  data() {
    return {
      data: {
        "titulo": "",
        "nombreModulo": "Módulo 1" ,
        "texto": "Aspectos generales y marco regulatorio"
      }
    }
  },
  created() {
    this.$store.commit('nextShow', true)
  }
}
</script>
